import { UiStatus } from '../../../common/type';
import { generateId } from '../../../util/generate-id';
import { AdsCheckoutAction } from './ads-checkout-action';
import { AdsCheckoutActionKey, CheckoutScreen, IAdsCheckoutStore } from './ads-checkout-type';

export const adsCheckoutReducer = (
  state: IAdsCheckoutStore = DEFAULT_STATE,
  action: AdsCheckoutAction
): IAdsCheckoutStore => {
  switch (action.type) {
    case AdsCheckoutActionKey.SetAdsTypeInfo:
      return {
        ...state,
        model: {
          ...state.model,
          adsTypeInfo: action.payload.adsTypeInfo
        }
      };

    case AdsCheckoutActionKey.SetCustomerId:
      return {
        ...state,
        model: {
          ...state.model,
          customerId: action.payload.customerId
        }
      };

    case AdsCheckoutActionKey.SetAds:
      return {
        ...state,
        model: {
          ...state.model,
          ads: action.payload.ads
        }
      };

    case AdsCheckoutActionKey.AddAds:
      return {
        ...state,
        model: {
          ...state.model,
          ads: state.model.ads.concat({
            id: generateId(),
            typeId: state.model.adsTypeInfo[0].idKey,
            name: ''
          })
        }
      };

    case AdsCheckoutActionKey.RemoveAds:
      return {
        ...state,
        model: {
          ...state.model,
          ads: state.model.ads.filter((ad, index) => index !== action.payload.index)
        }
      };

    case AdsCheckoutActionKey.SetAdsName:
      return {
        ...state,
        model: {
          ...state.model,
          ads: state.model.ads.map(
            (ad, index) =>
              index === action.payload.index
                ? {
                    ...ad,
                    name: action.payload.name
                  }
                : ad
          )
        }
      };

    case AdsCheckoutActionKey.SetAdsType:
      return {
        ...state,
        model: {
          ...state.model,
          ads: state.model.ads.map(
            (ad, index) =>
              index === action.payload.index
                ? {
                    ...ad,
                    typeId: action.payload.typeId
                  }
                : ad
          )
        }
      };

    case AdsCheckoutActionKey.SetDiscounts:
      return {
        ...state,
        model: {
          ...state.model,
          discounts: action.payload.discounts
        }
      };

    case AdsCheckoutActionKey.SetScreen:
      return {
        ...state,
        ui: {
          ...state.ui,
          screen: action.payload.screen
        }
      };

    case AdsCheckoutActionKey.SetUiStatus:
      return {
        ...state,
        ui: {
          ...state.ui,
          status: action.payload.status
        }
      };

    case AdsCheckoutActionKey.SetErrorMessage:
      return {
        ...state,
        ui: {
          ...state.ui,
          errorMessage: action.payload.error
        }
      };

    default:
      return state;
  }
};

const DEFAULT_STATE: IAdsCheckoutStore = {
  model: {
    customerId: '',
    ads: [],
    adsTypeInfo: [],
    discounts: []
  },
  ui: {
    screen: CheckoutScreen.user,
    status: UiStatus.Busy,
    errorMessage: ''
  }
};



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/parts/ads-checkout-reducer.ts